import MonthlyAgreement36Form from './MonthlyAgreement36Form'

export default MonthlyAgreement36Form;